var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTermometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465 991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.17,562.51V112.82C340.17,50.61,288.37,0,224.7,0S109.23,50.61,109.23,112.82V571.25C41.58,612.66,0,685.48,0,763.83,0,889.09,104.3,991,232.5,991S465,889.09,465,763.83C465,679.26,416.39,601.5,340.17,562.51ZM232.5,954.41c-107.55,0-195-85.49-195-190.58,0-68.77,38.19-132.47,99.68-166.22l9.55-5.25V112.82c0-42,35-76.23,78-76.23s78,34.2,78,76.23V585.65l10.92,4.89c69.2,31,113.91,99,113.91,173.29C427.55,868.92,340.05,954.41,232.5,954.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.79,646.21V268.33H190.37V648.59C139.8,663.61,103,709.51,103,763.83c0,66.52,55.19,120.45,123.27,120.45s123.27-53.93,123.27-120.45C349.53,706.21,308.11,658.07,252.79,646.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 108,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 168,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 226.89,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 286.89,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 345.78,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 405.78,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 464.67,
    width: 104,
    height: 33.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361,
    y: 524.67,
    width: 104,
    height: 33.33
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermometer);
export default __webpack_public_path__ + "static/media/termometer.dfa8b5b00c68783c8911baae41be17da.svg";
export { ForwardRef as ReactComponent };